import { render, staticRenderFns } from "./CourseVideo.vue?vue&type=template&id=285043ec&scoped=true"
import script from "./CourseVideo.vue?vue&type=script&lang=js"
export * from "./CourseVideo.vue?vue&type=script&lang=js"
import style0 from "./CourseVideo.vue?vue&type=style&index=0&id=285043ec&prod&scoped=true&lang=css"
import style1 from "./CourseVideo.vue?vue&type=style&index=1&id=285043ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285043ec",
  null
  
)

export default component.exports